<div class="directory-list">
  @for (item of directories(); track item?.id) {
    <accredible-directory-list-item [directory]="item" [isLoading]="isLoading()" />
  }
</div>
